import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getGorevlerim, gorevDurumGuncelle, getHasta } from '../services/api';

const DURUM_RENK = {
  0:  { bg: '#E8F4F8', text: '#1A6E8E', label: 'Yeni Görev' },
  1:  { bg: '#EAF6EA', text: '#2E7D32', label: 'Kabul Edildi' },
  11: { bg: '#FFF8E1', text: '#F57F17', label: 'Yola Çıkıldı' },
  2:  { bg: '#EDE7F6', text: '#512DA8', label: 'Konumuna Ulaşıldı' },
  3:  { bg: '#FFEBEE', text: '#C62828', label: 'Red / İptal' },
  4:  { bg: '#E8F5E9', text: '#1B5E20', label: 'Tamamlandı' },
};

const GECIS = {
  0:  [{ v: 1, l: 'Kabul Edildi' }, { v: 3, l: 'Red / İptal' }],
  1:  [{ v: 11, l: 'Yola Çıkıldı' }, { v: 3, l: 'Red / İptal' }],
  11: [{ v: 2, l: 'Konumuna Ulaşıldı' }, { v: 3, l: 'Red / İptal' }],
  2:  [{ v: 4, l: 'Tamamlandı' }, { v: 3, l: 'Red / İptal' }],
};

function fmtLocal(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function haritaLink(konum) {
  if (!konum) return null;
  if (konum.toLowerCase().startsWith('http')) return konum;
  if (konum.includes(',')) {
    const [a, b] = konum.split(',');
    if (!isNaN(a.trim()) && !isNaN(b.trim()))
      return `https://www.google.com/maps?q=${encodeURIComponent(konum)}`;
  }
  return null;
}

export default function Gorevler() {
  const navigate = useNavigate();
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const dokKod = kullanici.dokKod;

  const bugun = new Date();
  const hafta = new Date(); hafta.setDate(bugun.getDate() - 6);

  const [gorevler, setGorevler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [filtre, setFiltre] = useState({ durum: '0', basTarih: fmtLocal(hafta), bitTarih: fmtLocal(bugun) });

  // Hasta bilgi modal
  const [hastaModal, setHastaModal] = useState(null); // { gorev, hasta }
  const [hastaYukleniyor, setHastaYukleniyor] = useState(false);

  // Durum güncelle modal
  const [durumModal, setDurumModal] = useState(null); // { gorev }
  const [secilenDurum, setSecilenDurum] = useState('');
  const [ekipNotu, setEkipNotu] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const yukle = useCallback(async (params) => {
    if (!dokKod) return;
    setYukleniyor(true);
    try {
      const res = await getGorevlerim(dokKod, params);
      setGorevler(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setYukleniyor(false);
    }
  }, [dokKod]);

  useEffect(() => {
    yukle({ durum: filtre.durum, basTarih: filtre.basTarih, bitTarih: filtre.bitTarih });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFiltrele = () => {
    yukle({ durum: filtre.durum, basTarih: filtre.basTarih, bitTarih: filtre.bitTarih });
  };

  const handleTumAktif = () => {
    yukle({ aktif: true });
  };

  // Hasta bilgi modalını aç
  const openHastaModal = async (gorev) => {
    setHastaYukleniyor(true);
    setHastaModal({ gorev, hasta: null });
    try {
      const res = await getHasta(gorev.kayitNo);
      setHastaModal({ gorev, hasta: res.data });
    } catch {
      setHastaModal({ gorev, hasta: null });
    } finally {
      setHastaYukleniyor(false);
    }
  };

  // Durum modal
  const openDurumModal = (gorev) => {
    const gecisler = GECIS[gorev.ekipOnay] || [];
    setSecilenDurum(gecisler.length > 0 ? String(gecisler[0].v) : '');
    setEkipNotu(gorev.ekipNotu || '');
    setDurumModal({ gorev });
  };

  const handleDurumKaydet = async (e) => {
    e.preventDefault();
    if (!durumModal) return;
    setKaydediliyor(true);
    try {
      const res = await gorevDurumGuncelle({
        id: durumModal.gorev.id,
        durum: parseInt(secilenDurum),
        ekipNotu,
        dokKod,
      });
      const sonuc = res.data?.sonuc;
      if (sonuc === 'ok') {
        setDurumModal(null);
        handleFiltrele();
      } else if (sonuc === 'hata-1') {
        alert('Hasta dosyasına girip, Tıbbi işlem kaydı yapmadan TAMAMLANDI ONAYI veremezsiniz.');
      } else if (sonuc === 'hata-aktif') {
        alert(res.data?.mesaj || 'Tamamlanmamış bir göreviniz varken yeni göreve gidemezsiniz.');
      } else {
        alert('Kaydedilemedi, lütfen tekrar deneyiniz.');
      }
    } catch {
      alert('Kaydedilemedi, lütfen tekrar deneyiniz.');
    } finally {
      setKaydediliyor(false);
    }
  };

  const durumRenk = (d) => DURUM_RENK[d] || { bg: '#f0f0f0', text: '#333', label: d };

  return (
    <div style={{ minHeight: '100vh', background: '#D0D4DA' }}>
      {/* Başlık */}
      <div style={{ background: 'var(--med-dark)', color: '#fff', padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 600 }}>Görevlerim</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>{kullanici.adSoyad || ''}</div>
        </div>
        <button
          onClick={() => { localStorage.clear(); navigate('/gorevler-giris', { replace: true }); }}
          style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: 8, padding: '7px 12px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}
        >
          🚪 Çıkış
        </button>
      </div>

      <div style={{ padding: 16 }}>
      {/* Filtre alanı */}
      <div style={{
        background: 'linear-gradient(135deg, #e8f4f8 0%, #f0eaff 50%, #eafaf1 100%)',
        borderRadius: 14, padding: '16px', marginBottom: 16,
        boxShadow: '0 2px 10px rgba(100,120,200,.10)',
        border: '1px solid rgba(180,160,240,.25)'
      }}>
        {/* Durum seçimi */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 5, letterSpacing: '.4px', textTransform: 'uppercase' }}>📋 Durum</label>
          <select
            value={filtre.durum}
            onChange={e => setFiltre(f => ({ ...f, durum: e.target.value }))}
            style={{ background: '#fff', border: '1.5px solid #c5b3f0', borderRadius: 8, color: '#3d2f6e', fontWeight: 500 }}
          >
            <option value="0">Yeni Görev</option>
            <option value="1">Kabul Edildi</option>
            <option value="11">Yola Çıkıldı</option>
            <option value="2">Konumuna Ulaşıldı</option>
          </select>
        </div>

        {/* Tarihler yan yana */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: '#1A7A5E', display: 'block', marginBottom: 5, letterSpacing: '.4px', textTransform: 'uppercase' }}>📅 Başlangıç</label>
            <input
              type="date"
              value={filtre.basTarih}
              onChange={e => setFiltre(f => ({ ...f, basTarih: e.target.value }))}
              style={{ background: '#fff', border: '1.5px solid #99d9c4', borderRadius: 8, color: '#1a4d3a', fontWeight: 500, width: '100%' }}
            />
          </div>
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: '#1A7A5E', display: 'block', marginBottom: 5, letterSpacing: '.4px', textTransform: 'uppercase' }}>📅 Bitiş</label>
            <input
              type="date"
              value={filtre.bitTarih}
              onChange={e => setFiltre(f => ({ ...f, bitTarih: e.target.value }))}
              style={{ background: '#fff', border: '1.5px solid #99d9c4', borderRadius: 8, color: '#1a4d3a', fontWeight: 500, width: '100%' }}
            />
          </div>
        </div>

        {/* Butonlar */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <button
            onClick={handleFiltrele}
            style={{
              background: 'linear-gradient(135deg, #7C5CBF, #a07de0)',
              color: '#fff', border: 'none', borderRadius: 10,
              padding: '11px 8px', fontSize: 13, fontWeight: 700,
              cursor: 'pointer', boxShadow: '0 3px 8px rgba(124,92,191,.35)'
            }}
          >
            🔍 Filtrele
          </button>
          <button
            onClick={handleTumAktif}
            style={{
              background: 'linear-gradient(135deg, #1D9E75, #2dcf9a)',
              color: '#fff', border: 'none', borderRadius: 10,
              padding: '11px 8px', fontSize: 13, fontWeight: 700,
              cursor: 'pointer', boxShadow: '0 3px 8px rgba(29,158,117,.35)'
            }}
          >
            ⚡ Tüm Aktif
          </button>
        </div>
      </div>

      {/* Liste */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <h2 style={{ fontSize: 14, fontWeight: 600 }}>Görevlerim</h2>
        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{gorevler.length} kayıt</span>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {yukleniyor ? (
          <div className="loading">Yükleniyor...</div>
        ) : gorevler.length === 0 ? (
          <div className="empty">Görev bulunamadı</div>
        ) : (
          gorevler.map(g => {
            const dr = durumRenk(g.ekipOnay);
            const tarih = g.tar ? new Date(g.tar).toLocaleDateString('tr-TR') : '';
            const gecisler = GECIS[g.ekipOnay] || [];
            return (
              <div key={g.id} style={{ padding: '10px 14px', borderBottom: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                  {/* Hasta adı → hasta bilgi modal */}
                  <button
                    onClick={() => openHastaModal(g)}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', textAlign: 'left' }}
                  >
                    <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--med-dark)', textDecoration: 'underline' }}>{g.adSoy}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{tarih} · {g.saat}</div>
                  </button>
                  {/* Durum badge → durum modal */}
                  {gecisler.length > 0 ? (
                    <button
                      onClick={() => openDurumModal(g)}
                      style={{ background: dr.bg, color: dr.text, border: 'none', borderRadius: 6, padding: '4px 10px', fontSize: 11, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >
                      {dr.label}
                    </button>
                  ) : (
                    <span style={{ background: dr.bg, color: dr.text, borderRadius: 6, padding: '4px 10px', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>
                      {dr.label}
                    </span>
                  )}
                </div>
                {g.ekipNotu ? (
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', fontStyle: 'italic' }}>{g.ekipNotu}</div>
                ) : null}
              </div>
            );
          })
        )}
      </div>

      {/* ──────────────── HASTA BİLGİ MODALİ ──────────────── */}
      {hastaModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 480, maxHeight: '85vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            {/* Başlık */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: 'var(--med-dark)', color: '#fff', flexShrink: 0 }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>Hasta Bilgisi</span>
              <button onClick={() => setHastaModal(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>✕</button>
            </div>

            {/* İçerik */}
            <div style={{ overflowY: 'auto', padding: '14px 16px', flex: 1 }}>
              {hastaYukleniyor ? (
                <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: 20 }}>Yükleniyor...</div>
              ) : !hastaModal.hasta ? (
                <div style={{ color: '#c62828' }}>Kayıt bulunamadı.</div>
              ) : (
                <HastaAdresIcerik
                  hasta={hastaModal.hasta}
                  gorev={hastaModal.gorev}
                  onNavigate={(kayitNo, muayeneId, masterProtNo) => {
                    setHastaModal(null);
                    navigate(`/hasta/${kayitNo}?mprotno=${masterProtNo}&muayeneId=${muayeneId}`);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* ──────────────── DURUM GÜNCELLE MODALİ ──────────────── */}
      {durumModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 380 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: 'var(--med-dark)', color: '#fff', borderRadius: '12px 12px 0 0' }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>Görev Durumu</span>
              <button onClick={() => setDurumModal(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>✕</button>
            </div>
            <form onSubmit={handleDurumKaydet} style={{ padding: 16 }}>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, color: 'var(--text-muted)', display: 'block', marginBottom: 5 }}>Yeni Durum</label>
                <select value={secilenDurum} onChange={e => setSecilenDurum(e.target.value)} required>
                  {(GECIS[durumModal.gorev.ekipOnay] || []).map(g => (
                    <option key={g.v} value={g.v}>{g.l}</option>
                  ))}
                </select>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, color: 'var(--text-muted)', display: 'block', marginBottom: 5 }}>Görev Notu</label>
                <textarea
                  value={ekipNotu}
                  onChange={e => setEkipNotu(e.target.value)}
                  placeholder="Not ekle..."
                  style={{ width: '100%', height: 80, resize: 'vertical' }}
                />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={kaydediliyor}>
                {kaydediliyor ? 'Kaydediliyor...' : 'DURUMU GÜNCELLE'}
              </button>
            </form>
          </div>
        </div>
      )}
      </div> {/* padding:16 */}
    </div>
  );
}

function HastaAdresIcerik({ hasta, gorev, onNavigate }) { // onNavigate(kayitNo, muayeneId, masterProtNo)
  const konum = hasta.detay10 || '';
  const haritaUrl = haritaLink(konum);
  const kabul = gorev.ekipOnay >= 1 && gorev.ekipOnay !== 3;

  const satir = (label, deger) => {
    if (!deger || !deger.toString().trim()) return null;
    return (
      <tr key={label}>
        <td style={{ fontWeight: 700, fontSize: 12, padding: '5px 8px', verticalAlign: 'top', whiteSpace: 'nowrap', borderBottom: '1px solid #eee', width: 110 }}>{label}</td>
        <td style={{ fontSize: 12, padding: '5px 8px', borderBottom: '1px solid #eee' }}>{deger}</td>
      </tr>
    );
  };

  return (
    <>
      {/* Tıbbi dosya linki (kabul edilmiş görevlerde) */}
      {kabul && gorev.muayeneId > 0 && (
        <div style={{ marginBottom: 12, padding: '10px 12px', background: '#E8F4F8', borderRadius: 8 }}>
          <button
            onClick={() => onNavigate(gorev.kayitNo, gorev.muayeneId, gorev.masterProtNo)}
            className="btn btn-primary"
            style={{ width: '100%', fontSize: 13 }}
          >
            Tıbbi Dosyayı Aç →
          </button>
        </div>
      )}

      <div style={{ color: '#c00', fontWeight: 700, fontSize: 12, marginBottom: 6 }}>ADRES BİLGİSİ</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 12 }}>
        <tbody>
          {satir('Hasta', hasta.hesapAdi)}
          {satir('İl', hasta.sehir)}
          {satir('İlçe', hasta.evSemt)}
          {satir('Adres', hasta.adres1)}
        </tbody>
      </table>

      <div style={{ color: '#c00', fontWeight: 700, fontSize: 12, marginBottom: 6 }}>ADRES DETAYI</div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {satir('Mahalle', hasta.detay0)}
          {satir('Cadde', hasta.detay1)}
          {satir('Sokak', hasta.detay2)}
          {satir('İç Sokak', hasta.detay3)}
          {satir('Apt. Adı', hasta.detay4)}
          {satir('Apt. No', hasta.detay5)}
          {satir('Daire No', hasta.detay6)}
          {satir('Kat', hasta.detay7)}
          {satir('Zil Sırası', hasta.detay8)}
          {satir('Adres Tarifi', hasta.detay9)}
          {konum ? (
            <tr>
              <td style={{ fontWeight: 700, fontSize: 12, padding: '5px 8px', verticalAlign: 'top', whiteSpace: 'nowrap', borderBottom: '1px solid #eee', width: 110 }}>Google Maps</td>
              <td style={{ fontSize: 12, padding: '5px 8px', borderBottom: '1px solid #eee' }}>
                {haritaUrl
                  ? <a href={haritaUrl} target="_blank" rel="noopener noreferrer">{konum}</a>
                  : konum}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </>
  );
}
